module.exports = __webpack_public_path__ + "img/3.40d28477.jpg";